export type LangCode = 'en' | 'zh-TW' | 'ja';

export const lanList: LangCode[] = ['en', 'zh-TW', 'ja'];

export const LANGUAGE_NAME_MAP: Record<LangCode, string> = {
	'zh-TW': '繁中',
	en: 'EN',
	ja: '日本語',
};

export const LANGUAGE_MOMENT_CODE_MAP: Record<LangCode, string> = {
	en: 'en',
	ja: 'ja',
	'zh-TW': 'zh-tw',
};
